export default "__VITE_ASSET__098b9c97__"